export default __webpack_public_path__ + "static/media/close-icon.4a376aba.svg";